import { Card, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import StatusDistribution from "./StatisticsChart/StatusDistribution";
import StatusSummaryTable from "./StatisticsTables/StatusSummaryTable";
import OpenQueriesbyAgingBucket from "./StatisticsChart/OpenQueriesbyAgingBucket";
import SiteAgingHeatmap from "./StatisticsChart/SiteAgingHeatmap";
import SitePerformanceRiskRankingTable from "./StatisticsTables/SitePerformanceRiskRankingTable";
import QueriesBySiteChart from "./StatisticsChart/QueriesBySiteChart";
import AvgResolutionTimeChart from "./StatisticsChart/AvgResolutionTimeChart";
import SiteVsFormHeatmap from "./StatisticsChart/SiteVsFormHeatmap";
import QueryCategoryDistribution from "./StatisticsChart/QueryCategoryDistribution";
import ManualVsSystemQueries from "./StatisticsChart/ManualVsSystemQueries";
import StatusByPriority from "./StatisticsChart/StatusByPriority";
import TopFormsByQueryCount from "./StatisticsChart/TopFormsByQueryCount";
import TopFieldsByQueryCount from "./StatisticsChart/TopFieldsByQueryCount";
import FieldLevelRiskTable from "./StatisticsTables/FieldLevelRiskTable";
import QueryStatusByVisit from "./StatisticsChart/QueryStatusByVisit";
import SubjectWiseQuerySummaryTable from "./StatisticsTables/SubjectWiseQuerySummaryTable";
import SLAComplianceChart from "./StatisticsChart/SLAComplianceChart";
import TurnaroundMetrics from "./StatisticsTables/TurnaroundMetrics";
import QueryWorkloadTable from "./StatisticsTables/QueryWorkloadTable";
import QueryWorkloadChart from "./StatisticsChart/QueryWorkloadChart";
import DatabaseLockReadiness from "./StatisticsChart/DatabaseLockReadiness";
import CleaningReadinessMetricsTable from "./StatisticsTables/CleaningReadinessMetricsTable";
import QueryAlerts from "./StatisticsTables/QueryAlerts";
import QueryListingTable from "./StatisticsTables/QueryListingTable";

const QueryStatisticsDataList = () => {
  return (
    <>
      <div
        className="overflow-auto pt-2"
        style={{ height: "calc(100vh - 145px)" }}
      >
        <Container fluid>
          <Row className="g-2">
            <h6 className="mb-1 mt-2 fw-bold">Query status summary</h6>
            <Form.Group as={Col} md={4}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">Status distribution</span>{" "}
                  <small>all queries in scope</small>
                </div>
                <Card.Body className="p-0">
                  <StatusDistribution />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={8}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">Status summary table</span>{" "}
                </div>
                <Card.Body className="p-0">
                  <StatusSummaryTable />
                </Card.Body>
              </Card>
            </Form.Group>
            <h6 className="mb-1 mt-2 fw-bold">
              Query aging analysis — open + answered (unresolved) queries
            </h6>
            <Form.Group as={Col} md={4}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">
                    Open queries by aging bucket
                  </span>{" "}
                </div>
                <Card.Body className="p-0">
                  <OpenQueriesbyAgingBucket />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={8}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">
                    Heatmap — site vs aging bucket
                  </span>{" "}
                  <small>unresolved query count</small>
                </div>
                <Card.Body className="p-0">
                  <SiteAgingHeatmap />
                </Card.Body>
              </Card>
            </Form.Group>
            <h6 className="mb-1 mt-2 fw-bold">Site-wise query performance</h6>
            <Form.Group as={Col} md={8}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">
                    Site performance & risk ranking
                  </span>{" "}
                  <small>sorted by unresolved queries</small>
                </div>
                <Card.Body className="p-0">
                  <SitePerformanceRiskRankingTable />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={4}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">
                    Open queries by aging bucket
                  </span>{" "}
                </div>
                <Card.Body className="p-0">
                  <QueriesBySiteChart />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={6}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">
                    Average resolution time by site (days)
                  </span>{" "}
                </div>
                <Card.Body className="p-0">
                  <AvgResolutionTimeChart />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={6}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">Heatmap — site vs form</span>{" "}
                  <small>total query count</small>
                </div>
                <Card.Body className="p-0">
                  <SiteVsFormHeatmap />
                </Card.Body>
              </Card>
            </Form.Group>
            <h6 className="mb-1 mt-2 fw-bold">Category, source & priority</h6>
            <Form.Group as={Col} md={4}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">Query category distribution</span>
                </div>
                <Card.Body className="p-0">
                  <QueryCategoryDistribution />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={4}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">Manual vs system queries</span>{" "}
                  <small>by source</small>
                </div>
                <Card.Body className="p-0">
                  <ManualVsSystemQueries />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={4}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">Status by priority</span>{" "}
                </div>
                <Card.Body className="p-0">
                  <StatusByPriority />
                </Card.Body>
              </Card>
            </Form.Group>
            <h6 className="mb-1 mt-2 fw-bold">Form, field & visit analytics</h6>
            <Form.Group as={Col} md={6}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">Top 10 forms by query count</span>
                </div>
                <Card.Body className="p-0">
                  <TopFormsByQueryCount />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={6}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">Top 10 fields by query count</span>
                </div>
                <Card.Body className="p-0">
                  <TopFieldsByQueryCount />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={8}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">Field-level risk table</span>{" "}
                  <small>most queried fields</small>
                </div>
                <Card.Body className="p-0">
                  <FieldLevelRiskTable />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={4}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">Query status by visit</span>
                </div>
                <Card.Body className="p-0">
                  <QueryStatusByVisit />
                </Card.Body>
              </Card>
            </Form.Group>
            <h6 className="mb-1 mt-2 fw-bold">
              Subject-wise query summary — click a row to filter the query
              listing to that subject
            </h6>
            <Form.Group as={Col} md={12}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom hstack gap-2">
                  <Form.Control
                    type="search"
                    placeholder="Search subject / site…"
                    className="w-auto"
                  />
                  <small>
                    Showing subjects with ≥1 query, ranked by open queries
                  </small>
                </div>
                <Card.Body className="p-0">
                  <SubjectWiseQuerySummaryTable />
                </Card.Body>
              </Card>
            </Form.Group>
            <h6 className="mb-1 mt-2 fw-bold">
              Turnaround time & SLA compliance
            </h6>
            <Form.Group as={Col} md={4}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">SLA compliance</span>{" "}
                  <small>closed queries</small>
                </div>
                <Card.Body className="p-0">
                  <SLAComplianceChart />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={8}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">
                    Turnaround metrics & SLA rules
                  </span>{" "}
                  <small>SLA configurable by admin</small>
                </div>
                <Card.Body className="p-0">
                  <TurnaroundMetrics />
                </Card.Body>
              </Card>
            </Form.Group>
            <h6 className="mb-1 mt-2 fw-bold">User performance summary</h6>
            <Form.Group as={Col} md={12}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">Query workload by user</span>{" "}
                </div>
                <Card.Body className="p-0">
                  <Row>
                    <Form.Group as={Col} md={8}>
                      <QueryWorkloadTable />
                    </Form.Group>
                    <Form.Group as={Col} md={4}>
                      <QueryWorkloadChart />
                    </Form.Group>
                  </Row>
                </Card.Body>
              </Card>
            </Form.Group>
            <h6 className="mb-1 mt-2 fw-bold">
              Data cleaning & database lock readiness
            </h6>
            <Form.Group as={Col} md={8}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">Database lock readiness</span>{" "}
                  <small>
                    forms with no open query and SDV/freeze complete
                  </small>
                </div>
                <Card.Body>
                  <DatabaseLockReadiness />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={4}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom">
                  <span className="fw-bold">Cleaning readiness metrics</span>
                </div>
                <Card.Body className="p-0">
                  <CleaningReadinessMetricsTable />
                </Card.Body>
              </Card>
            </Form.Group>
            <h6 className="mb-1 mt-2 fw-bold">Alerts & notifications</h6>
            <Form.Group as={Col} md={12}>
              <QueryAlerts />
            </Form.Group>
            <h6 className="mb-1 mt-2 fw-bold">
              Query listing — 900 queries match current filters
            </h6>
            <Form.Group as={Col} md={12}>
              <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
                <div className="bg-light p-2 border-bottom hstack gap-2">
                  <Form.Control
                    type="search"
                    placeholder="Search query ID, text, subject, field…"
                    className="w-auto"
                  />
                  <InputGroup className="e-auto">
                    <button className="updateProfile">All</button>
                    <button className="updateProfile">Open</button>
                    <button className="updateProfile">Answered</button>
                    <button className="updateProfile">Closede</button>
                    <button className="updateProfile">Re-Opend</button>
                    <button className="updateProfile">Re-Opendbutton</button>
                  </InputGroup>
                  <Form.Select className="w-auto">
                    <option value="">No grouping</option>
                    <option value="site">Group by site</option>
                    <option value="form">Group by form</option>
                    <option value="status">Group by status</option>
                  </Form.Select>
                </div>
                <Card.Body className="p-0">
                  <QueryListingTable />
                </Card.Body>
              </Card>
            </Form.Group>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default QueryStatisticsDataList;
